import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { useShoppingContext } from '@components/products/ProductShoppingContext';
import { CartItem, ProductCode } from '@contracts';
import useProductPrices from '@utils/useProductPrices';
import ShoppingAddon from './ShoppingAddon';

interface Props {}

const ShoppingAddons: React.FC<Props> = () => {
  const { setSelectedAddonCartItems, productHeaderData } = useShoppingContext();
  const productCodes: ProductCode[] = useMemo(() => (productHeaderData.addonProducts?.split(',') as ProductCode[]) ?? [], [productHeaderData]);
  const [addonChecked, setAddonChecked] = useState(false);
  const productPrices = useProductPrices(productCodes);

  function handleCheckboxClick(cartItem: CartItem) {
    setAddonChecked((prev) => {
      const currentValue = !prev;

      if (currentValue) {
        setSelectedAddonCartItems([cartItem]);
      } else {
        setSelectedAddonCartItems([]);
      }

      return currentValue;
    });
  }

  return (
    <Container>
      {productCodes.map((productCode) => {
        const price = productPrices[productCode];
        if (!price) return null;

        return (
          <ShoppingAddon
            key={productCode}
            productCode={productCode}
            price={price}
            handleCheckboxClick={handleCheckboxClick}
            addonChecked={addonChecked}
          />
        );
      })}
    </Container>
  );
};

export default ShoppingAddons;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;
